<div class="accordion" id="frontline-distribution-{{device}}">
    <div class="border-bottom" *ngFor="let frontLineRow of frontlineDataDistribution; let i=index">
        <div class="container-fluid">
            <div class="row py-3">
                <div class="col-12 d-flex align-items-center justify-content-between"
                    id="heading-{{device}}-{{frontLineRow.zip}}" data-toggle="collapse"
                    attr.data-target="#collapse-{{device}}-{{frontLineRow.zip}}"
                    attr.aria-expanded="{{i == 0 ? true : false}}"
                    attr.aria-controls="collapse-{{device}}-{{frontLineRow.zip}}">
                    <div class="">
                        <div class="subtitle">{{frontLineRow.zip}} ({{frontLineRow.city.city}}, {{frontLineRow.state}})
                        </div>
                        <div class="footnote">NEAR {{frontLineRow.nearestZip}}</div>
                    </div>
                    <div class="btn-svg">
                        <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 9L9 1L1 9" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <div id="collapse-{{device}}-{{frontLineRow.zip}}" [ngClass]="{'collapse ':true,'show ': i == 0 }"
                attr.aria-labelledby="heading-{{device}}-{{frontLineRow.zip}}"
                attr.data-parent="#frontline-distribution-{{device}}">
                <div class="my-4 mx-2 mx-lg-4">

                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="border-top w-100 pb-3"></div>
                                    <div class="footnote text-uppercase">Racial / ethnic distribution</div>
                                </div>
                                <div class="col-12">
                                    <div class="row align-items-center justify-content-between">
                                        <div class="col-12 col-md">
                                            <div *ngIf="frontLineRow.white > 0" class="chart-key pt-2 dark-gray">
                                                {{frontLineRow.white| number:'1.1-1'}}% <span class="ml-2">White
                                                    (including
                                                    hispanic
                                                    white)</span></div>
                                            <div *ngIf="frontLineRow.black > 0" class="chart-key pt-2 red">
                                                {{frontLineRow.black|
                                                number:'1.1-1'}}% <span class="ml-2">Black</span></div>
                                            <div *ngIf="frontLineRow.asian > 0" class="chart-key pt-2 blue">
                                                {{frontLineRow.asian|
                                                number:'1.1-1'}}% <span class="ml-2">Asian American</span></div>
                                            <div *ngIf="frontLineRow.indianOrAlaskan > 0" class="chart-key pt-2 purple">
                                                {{frontLineRow.indianOrAlaskan| number:'1.1-1'}}% <span
                                                    class="ml-2">American
                                                    Indian
                                                    or Alaskan Native</span>
                                            </div>
                                            <div *ngIf="frontLineRow.hawaiianOrPacific > 0" class="chart-key pt-2 pink">
                                                {{frontLineRow.hawaiianOrPacific| number:'1.1-1'}}% <span
                                                    class="ml-2">Native
                                                    Hawaiian or Pacific Islander</span>
                                            </div>
                                            <div *ngIf="frontLineRow.latino > 0" class="chart-key pt-2 green">
                                                {{frontLineRow.latino| number:'1.1-1'}}% <span class="ml-2">Latino
                                                    (hispanic
                                                    non-white)</span></div>
                                            <div *ngIf="frontLineRow.mixed > 0" class="chart-key pt-2 yellow">
                                                {{frontLineRow.mixed|
                                                number:'1.1-1'}}% <span class="ml-2">Mixed</span></div>
                                            <div *ngIf="frontLineRow.other > 0" class="chart-key pt-2 orange">
                                                {{frontLineRow.other|
                                                number:'1.1-1'}}% <span class="ml-2">Other</span></div>
                                        </div>
                                        <div class="col-12 col-md-auto d-flex justify-content-center">
                                            <div class="pie-chart"
                                                [ngStyle]="{'background': frontLineRow.pieChartStyle}"></div>
                                        </div>
                                    </div>
                                    <div class="border-bottom w-100 pt-3"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="footnote text-uppercase pt-3">Gender distribution</div>
                                    <div class="pt-3 pb-4">As it currently stands, the US census does not collect data
                                        that
                                        accurately reflects the gender identities of all individuals. These numbers do
                                        not accurately reflect the number of individuals who may identify as a gender
                                        outside the male/female binary. </div>

                                    <div class="gender-chart">
                                        <div class="gender-chart-men green"
                                            [ngStyle]="{'width': frontLineRow.male + '%'}">
                                        </div>
                                        <div class="gender-chart-women red"
                                            [ngStyle]="{'width':frontLineRow.female + '%'}">
                                        </div>
                                    </div>
                                    <div class="gender-chart-key d-flex w-100 pt-2">
                                        <div class="gender-chart-key-male"
                                            [ngStyle]="{'width': frontLineRow.male + '%'}"><b>{{frontLineRow.male|
                                                number:'1.2-2'}}%</b> Male
                                        </div>
                                        <div class="gender-chart-key-female"
                                            [ngStyle]="{'width':frontLineRow.female + '%'}">
                                            <b>{{frontLineRow.female|
                                                number:'1.2-2'}}%</b>Female
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="border-bottom w-100 pt-3"></div>
                                    <div class="footnote text-uppercase py-3">Age distribution by generation</div>
                                    <div class="age-distribution border-bottom">
                                        <div class="age-distribution-legend d-flex align-items-center pt-2 pt-lg-0">
                                            <div class="age-name">
                                                <div>Gen Z</div>
                                                <div><small>b. 1996-2015</small></div>
                                            </div>
                                            <div class="age-percent"><b>{{frontLineRow.genZ|number:'1.2-2'}}%</b></div>
                                        </div>
                                        <div class="age-chart-container">
                                            <div class="age-chart yellow" [ngStyle]="{'width':frontLineRow.genZ + '%'}">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="age-distribution border-bottom">
                                        <div class="age-distribution-legend d-flex align-items-center pt-2 pt-lg-0">
                                            <div class="age-name">
                                                <div>Millenial</div>
                                                <div><small>b. 1977-1995</small></div>
                                            </div>
                                            <div class="age-percent"><b>{{frontLineRow.millennials|number:'1.2-2'}}%</b>
                                            </div>
                                        </div>
                                        <div class="age-chart-container">
                                            <div class="age-chart pink"
                                                [ngStyle]="{'width':frontLineRow.millennials + '%'}">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="age-distribution border-bottom">
                                        <div class="age-distribution-legend d-flex align-items-center pt-2 pt-lg-0">
                                            <div class="age-name">
                                                <div>Gen X</div>
                                                <div><small>b. 1965-1976</small></div>
                                            </div>
                                            <div class="age-percent"><b>{{frontLineRow.genX|number:'1.2-2'}}%</b></div>
                                        </div>
                                        <div class="age-chart-container">
                                            <div class="age-chart blue" [ngStyle]="{'width':frontLineRow.genX + '%'}">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="age-distribution">
                                        <div class="age-distribution-legend d-flex align-items-center pt-2 pt-lg-0">
                                            <div class="age-name">
                                                <div>Baby Boomers</div>
                                                <div><small>b. 1946-1964</small></div>
                                            </div>
                                            <div class="age-percent"><b>{{frontLineRow.babyBoomers|number:'1.2-2'}}%</b>
                                            </div>
                                        </div>
                                        <div class="age-chart-container">
                                            <div class="age-chart purple"
                                                [ngStyle]="{'width':frontLineRow.babyBoomers + '%'}">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="border-bottom w-100 pt-3"></div>
                                    <div class="footnote text-uppercase pt-3">Median annual earnings</div>
                                    <div class="pt-3 pb-4">This number may not reflect the living wage for this
                                        community based on costs of living. We’ll dive deeper into living wage and costs
                                        of living in the future.</div>
                                    <div class="fl-big-number py-3">
                                        {{frontLineRow.median_earnings_thousands}}K
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>